export const FREE_PRODUCT_TIER = 'free'
export const PAID_PRODUCT_TIER = 'paid'

export const LESSON_MODULE_TYPES = {
  SKILL_EXERCISE: 'Skills Lesson',
  WRITING_MODULES: 'Writing Modules',
  DIRECT_INSTRUCTION: 'Direct Instruction',
  PRACTICE: 'Practice',
  ASSESSMENT: 'Assessment',
  CORE_ELA: 'Core ELA',
}
